const nsp = 'auth/';

export const SET_USER = `${nsp}SET_USER`;
export const SET_TOKEN = `${nsp}SET_TOKEN`;
export const RESET_USER = `${nsp}RESET_USER`;
export const SET_LOADER_TRUE = `${nsp}SET_LOADER_TRUE`;
export const SET_LOADER_FALSE = `${nsp}SET_LOADER_FALSE`;
